import React, { useState, useEffect } from "react";

const JornayaLeadIdReset = ({ resetUrl, runUpdate }) => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (loading) {
            const timer = setTimeout(() => {setLoading(false);runUpdate();}, 3000);
            return () => clearTimeout(timer);
        }
    }, [loading]);

    const handleClick = () => {
        setLoading(true);
    };

    return (
        <div className="mt-3">
            {resetUrl && (
                <button
                    type="button"
                    onClick={handleClick}
                    className="btn btn-outline-danger"
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Resetting...
                        </>
                    ) : (
                        "Reset LeadID Age"
                    )}
                </button>
            )}

            {loading && (
                <iframe
                    src={resetUrl}
                    style={{
                        width: "0",
                        height: "0",
                        border: "none",
                    }}
                    title="LeadID Reset"
                />
            )}
        </div>
    );
};

export default JornayaLeadIdReset;
